<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="label"
    :vid="vid"
    :rules="rules"
    :ref="refName"
    tag="div"
  >
    <label
      v-if="label"
      class="form-label"
    >
      {{ label }}<small v-if="isRequire">*</small>
    </label>

    <input
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :type="type"
      :maxlength="maxlength"
      class="form__input form-control"
      @input="$emit('change', $event.target.value)"
    >
    <p
      v-if="note"
      class="form__group-notes"
    >
      {{ note }}
    </p>
    <span
      v-if="errors[0]"
      class="form-error"
    >{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'InputText',

  model: {
    prop: 'value',
    event: 'change'
  },

  computed: {
    noneText () {
      return this.text.split('\n')
    }
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: () => {}
    },
    vid: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 100
    },
    type: {
      type: String,
      default: 'text'
    },
    refName: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isRequire: {
      type: Boolean,
      default: false
    },
    note: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import '../..//assets/css/form.pcss';
</style>



// WEBPACK FOOTER //
// src/components/parts/InputText.vue